import type { FaireProductEntity } from "../../entity_types/product";

export const p_tjqnuvxgws: FaireProductEntity = {
  token: "p_tjqnuvxgws",
  type: "product",
  name: "Hylands Homeopathic Baby Tiny Cold Tablets - 125 Tablets",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/50c10fd75ed1a359ff83ead879eb565ea77e673b91fed9a1ae8c16465fbb4420.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/711388c9c4ac5c91d29c3e67c0d2925c935a2242290b13567ccd6c0675fecbca.jpeg",
    "https://cdn.faire.com/fastly/850e7d5f3b99121228ffb533ef85d559bd2d80db29d5e50dce0e537b6aba00a1.jpeg",
  ],
  priceDollars: 21.13,
  description:
    "Ensure your little one finds natural relief from common cold symptoms with these specially formulated tablets. These homeopathic remedies, containing active ingredients like kali iodatum and gelsemium sempervirens, are crafted to soothe runny noses, ease sneezing, and alleviate congestion in children aged 6 months to 3 years. Parents can rest assured knowing these tablets are free from parabens, artificial flavors, and dyes, making them a safe choice for their child.\n\n * Suitable for ages 6 months to 3 years \n * Contains 125 quick-dissolving tablets \n * Free from artificial additives \nSimply administer two to three tablets every 15 minutes for the initial doses, then continue hourly until symptoms are relieved. Made in the USA, this package provides a convenient solution to keep your child comfortable during cold season.",
  tags: [],
  msrpDollars: 27.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:09.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
